import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import './index.css';
import App from './App';

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));

function AppOrSetupMessage() {
  const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID;
  if (!clientId || clientId.trim() === '') {
    return (
      <div className="auth-loading">
        <div className="auth-loading-content">
          <p style={{ maxWidth: '420px', marginBottom: 8 }}>
            Microsoft Entra SSO is not configured. Copy <code>.env.example</code> to <code>.env.local</code> and set <code>REACT_APP_ENTRA_CLIENT_ID</code> (and other Entra variables). See <code>ENTRA_SSO_SETUP.md</code>.
          </p>
        </div>
      </div>
    );
  }
  return <App />;
}

msalInstance.initialize().then(() => {
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <AppOrSetupMessage />
      </MsalProvider>
    </React.StrictMode>
  );
});
